import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import * as Ant from 'antd';
import * as AppActions from '../../AppActions';

const F = AppActions.F;

export default function TeamOfficierList(props) {
  const {data} = props;

  if (!data) {
    return <Wrapper />;
  }

  return (
    <Wrapper>
      <div className="title">
        <h2>{F(data, 'title')}</h2>
      </div>
      <div className="container">
        <Ant.Descriptions bordered column={1}>
          {Array.isArray(data.groups) &&
            data.groups.length > 0 &&
            data.groups.map((it, index) => {
              return (
                <Ant.Descriptions.Item
                  label={<span className="group-label">{F(it, 'name')}</span>}
                  children={
                    <div className="group-grid">
                      {it.list?.map((person, idx) => {
                        return <div className="item">{F(person, 'name')}</div>;
                      })}
                    </div>
                  }
                />
              );
            })}
        </Ant.Descriptions>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 40px;

  & > .title {
    margin-top: 10px;
    margin-bottom: 15px;
  }

  & > .container {
  }

  .group-label {
    display: block;
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 0.95rem;
  }

  .group-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);

    & > .item {
      border-right: 1px solid #ccc;
      margin: 8px 0px;
      padding: 0px 5px;
      word-break: break-word;
      text-align: center;
      font-size: 0.95rem;
    }

    & > .item:nth-child(5n),
    & > .item:last-child {
      border-right: none;
    }

    @media screen and (max-width: 1000px) {
      grid-template-columns: repeat(4, 1fr);

      & > .item:nth-child(5n) {
        border-right: 1px solid #ccc;
      }

      & > .item:nth-child(4n),
      & > .item:last-child {
        border: none;
      }
    }

    @media screen and (max-width: 900px) {
      grid-template-columns: repeat(3, 1fr);

      & > .item:nth-child(4n) {
        border-right: 1px solid #ccc;
      }

      & > .item:nth-child(3n),
      & > .item:last-child {
        border: none;
      }
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: repeat(2, 1fr);

      & > .item:nth-child(3n) {
        border-right: 1px solid #ccc;
      }

      & > .item:nth-child(2n),
      & > .item:last-child {
        border: none;
      }
    }

    @media screen and (max-width: 500px) {
      grid-template-columns: repeat(1, 1fr);

      & > .item:nth-child(2n) {
        border-right: 1px solid #ccc;
      }

      & > .item:nth-child(1n),
      & > .item:last-child {
        border: none;
      }
    }
  }
`;
